import React from 'react';
import { observer } from 'mobx-react';

import { modalStore } from 'apps/modals/app';
import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { Trans } from 'react-i18next';
import { Form } from 'libs/forms';

import { ThreadFormAppManager } from 'apps/forum/threadForm/appManager';

@observer
export class ThreadForm extends Modal {
  UNSAFE_componentWillMount() {
    this.appManager = new ThreadFormAppManager(
      modalStore.props.parent,
      modalStore.props,
    );
  }

  render() {
    const { threadApp, categoryTitle, categoryColor } = this.appManager;
    const { form } = threadApp;
    const {
      conf: { formTitle },
    } = form;

    const displayTitle = categoryTitle
      ? `New "${categoryTitle}" Thread`
      : formTitle;

    return (
      <>
        <ModalTitle level={2}>
          <Trans>{displayTitle}</Trans>
        </ModalTitle>
        <Form
          formStore={form}
          formTitle=''
          formTitleColor={categoryColor}
          buttonHandler={threadApp.Submit}
          noBorder
          padding='0'
          responsive
        />
      </>
    );
  }
}
